import React, { Component } from "react";
import InstagramFeed  from 'react-ig-feed'
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from 'react-router-dom';

export default class ModInstagram extends Component {
	render () {
		let block = this.props.block;
		return (
			<div className={'l-block l-block--display-' + block.display + ' scope-' + block.text_color} style={{backgroundColor: block.block_color}}>
				<div className="l-content">
	    			<div className="l-grid">
	    				<div className="l-grid__col">
	    					<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
		    					{block.heading &&
		    						<h2 className="c-product-gallery__heading c-product-gallery__heading--alt">{ block.heading }</h2>
		    					}
		    					{block.link_text && block.link_url &&
			        				<a href={ block.link_url } className="c-product-gallery__link">{ block.link_text }</a>
		        				}
								<div className="c-instagram">
									<InstagramFeed className="c-instagram__inner" token={block.token}  counter="4"></InstagramFeed>
								</div>
							</ScrollAnimation>
						</div>
					</div>
				</div>
			</div>
		);
	}
}